// extracted by mini-css-extract-plugin
export default {"header":"style_header__Yfcaz","header_title":"style_header_title__hFe2P"};